<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e363">
<div class="tx38">
<p class="h7" id="d41151131" style="text-align:right;margin-right: 10%;margin-left: 10%"><b>The Gun Seller </b></p>
</div>
<hr/>
<div class="tx39">
<p class="hr" id="d41151161"><b>Hugh Laurie </b></p>
</div>
<p class="hr" id="d417852" style="text-align:right;margin-top:40%;"><img alt="1114115119" id="d11141151191" src="images/9781569470879_opt_0004_001.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap4_thegunse_9781569478004_epub_part4.vue?41c69ee0